import update from 'react-addons-update';
import { makeActionCreator } from 'crazyEditor/redux/helpers';

const SET_EBAY_CONNECTED = 'crazyEditor/user/SET_EBAY_CONNECTED';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_EBAY_CONNECTED: {
      return update(state, {
        planDetails: {
          token: {
            $set: true
          }
        }
      });
    }
    default:
      break;
  }
  return state;
}

export const setEbayConnected = makeActionCreator(SET_EBAY_CONNECTED);
